module.exports = __webpack_public_path__ + "9a8f95b5ba3bfb7404a4acfa4728e222.png";